var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _g, _path120, _g2, _path121, _g3, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1261153142(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 180,
    viewBox: "0 0 170 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.215 179.832H160.436V179.943H169.215V179.832Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.625 179.057H102.928V179.168H116.625V179.057Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.97 175.707H138.074V175.818H159.97V175.707Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2654 176.453H0.34375V176.564H18.2654V176.453Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3706 178.328H46.2031V178.439H71.3706V178.328Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.215 179.832H160.436V179.943H169.215V179.832Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.625 179.057H102.928V179.168H116.625V179.057Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.97 175.707H138.074V175.818H159.97V175.707Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2654 176.453H0.34375V176.564H18.2654V176.453Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3706 178.328H46.2031V178.439H71.3706V178.328Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.937 173.307C163.664 173.307 165.064 171.967 165.064 170.315C165.064 168.663 163.664 167.324 161.937 167.324C160.209 167.324 158.809 168.663 158.809 170.315C158.809 171.967 160.209 173.307 161.937 173.307Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.808 173.307C160.535 173.307 161.936 171.967 161.936 170.315C161.936 168.663 160.535 167.324 158.808 167.324C157.08 167.324 155.68 168.663 155.68 170.315C155.68 171.967 157.08 173.307 158.808 173.307Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.962 173.307C121.689 173.307 123.09 171.967 123.09 170.315C123.09 168.663 121.689 167.324 119.962 167.324C118.234 167.324 116.834 168.663 116.834 170.315C116.834 171.967 118.234 173.307 119.962 173.307Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.633 101.539H108.891V167.929H161.633V101.539Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.065 101.539H119.117V167.929H165.065V101.539Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.276 104.975H123.271V164.568H161.276V104.975Z",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.271 123.953H161.634",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.271 144.684H161.634",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.41 107.469H136.295V109.078H150.41V107.469Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.41 126.553H136.295V128.162H150.41V126.553Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.41 147.945H136.295V149.554H150.41V147.945Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.835 173.307C118.562 173.307 119.963 171.967 119.963 170.315C119.963 168.663 118.562 167.324 116.835 167.324C115.107 167.324 113.707 168.663 113.707 170.315C113.707 171.967 115.107 173.307 116.835 173.307Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.051 36.8926H12.2051V100.131H108.051V36.8926Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.915 36.8926H108.051V100.131H109.915V36.8926Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.104 43.2656H14.8594V96.9968H106.104V43.2656Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0713 96.9973H50.8122L27.0391 43.1816H35.2981L59.0713 96.9973Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5338 96.9973H62.5681L38.7949 43.1816H53.7699L77.5338 96.9973Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7444 97.0143H91.4807L67.7168 43.2031H75.9712L99.7444 97.0143Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.919 33.6562H12.2051V60.0707H109.919V33.6562Z",
    fill: "#E0E0E0",
    stroke: "#F0F0F0",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.64 54.5605H12.2051V55.3784H109.64V54.5605Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.64 50.7773H12.2051V51.5952H109.64V50.7773Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.64 46.9902H12.2051V47.808H109.64V46.9902Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.64 43.209H12.2051V44.0268H109.64V43.209Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.64 39.4199H12.2051V40.2377H109.64V39.4199Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.721 32.5234H11.0469V33.6346H111.721V32.5234Z",
    fill: "#E0E0E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7079 33.0786C11.7079 34.0698 11.099 34.8565 10.3554 34.8565C9.61175 34.8565 9.02148 34.0653 9.02148 33.0786C9.02148 32.0919 9.63034 31.3008 10.3786 31.3008C11.1269 31.3008 11.7079 32.083 11.7079 33.0786Z",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.075 33.0786C113.075 34.0698 112.466 34.8565 111.722 34.8565C110.979 34.8565 110.365 34.052 110.365 33.0786C110.365 32.1053 110.974 31.3008 111.722 31.3008C112.471 31.3008 113.075 32.083 113.075 33.0786Z",
    fill: "#E0E0E0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.2 57.5682L141.296 87.1161C141.183 87.4549 140.98 87.7598 140.707 88.001C140.433 88.2422 140.099 88.4114 139.737 88.492C139.375 88.5727 138.997 88.562 138.641 88.4611C138.284 88.3601 137.961 88.1724 137.703 87.9162L132.553 82.8182C132.164 82.4349 131.635 82.2111 131.077 82.1936C130.518 82.1762 129.975 82.3667 129.56 82.7248L86.5548 120.06C86.1707 120.393 85.6738 120.582 85.1555 120.593C84.6372 120.603 84.1323 120.435 83.7336 120.118L56.4282 98.4055C56.0335 98.0951 55.5362 97.9291 55.0253 97.9372C54.5144 97.9454 54.0231 98.1271 53.6395 98.45L0 143.91L2.03571 125.687C2.08798 125.172 2.34206 124.696 2.74681 124.353L53.3653 81.4537C53.7499 81.1323 54.2413 80.9519 54.752 80.9446C55.2626 80.9372 55.7595 81.1035 56.154 81.4137L83.3479 103.086C83.7465 103.403 84.2514 103.571 84.7697 103.561C85.2881 103.55 85.7849 103.361 86.169 103.028L120.098 73.5556C120.311 73.3704 120.483 73.1461 120.604 72.896C120.725 72.6459 120.792 72.3751 120.801 72.0997C120.81 71.8244 120.761 71.5501 120.657 71.2931C120.553 71.0362 120.396 70.802 120.195 70.6043L115.129 65.5641C114.864 65.3024 114.677 64.9781 114.586 64.6244C114.495 64.2706 114.504 63.9002 114.611 63.5508C114.719 63.2014 114.922 62.8856 115.199 62.6357C115.476 62.3859 115.818 62.2108 116.189 62.1284L148.667 54.937C149.038 54.854 149.424 54.8666 149.788 54.9735C150.152 55.0804 150.479 55.2778 150.737 55.5455C150.995 55.8131 151.173 56.1415 151.255 56.4969C151.336 56.8523 151.317 57.222 151.2 57.5682Z",
    fill: "#407BFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.186 57.6166L141.314 87.0846C141.198 87.4276 140.991 87.7361 140.714 87.9799C140.436 88.2238 140.097 88.3948 139.73 88.4762C139.362 88.5577 138.979 88.5468 138.617 88.4447C138.256 88.3426 137.928 88.1527 137.666 87.8935L132.553 82.8533C132.159 82.4635 131.621 82.2354 131.054 82.2172C130.487 82.1989 129.935 82.3919 129.514 82.7555L86.5548 120.059C86.1309 120.429 85.5713 120.624 84.9978 120.602C84.5169 120.587 84.0553 120.418 83.6871 120.122L56.4421 98.4361C56.0395 98.1202 55.5329 97.9509 55.0122 97.9583C54.4915 97.9656 53.9904 98.1491 53.5977 98.4762L0 143.909L2.12402 124.917L53.3467 81.5065C53.7386 81.1778 54.24 80.9932 54.7612 80.9859C55.2824 80.9785 55.7894 81.1489 56.1911 81.4665L67.7686 90.6803L83.3246 103.085C83.7299 103.405 84.2419 103.575 84.7673 103.565C85.2928 103.554 85.7968 103.363 86.1876 103.027L120.102 73.5729C120.319 73.3855 120.495 73.1581 120.618 72.9043C120.742 72.6505 120.81 72.3755 120.82 72.0958C120.829 71.8161 120.78 71.5375 120.674 71.2765C120.568 71.0156 120.408 70.7777 120.204 70.5772L115.18 65.6036C114.912 65.3377 114.723 65.0086 114.631 64.6497C114.539 64.2909 114.549 63.9153 114.658 63.5611C114.768 63.2069 114.974 62.8868 115.255 62.6335C115.536 62.3802 115.882 62.2027 116.258 62.1191L148.625 54.9454C149 54.8648 149.391 54.8802 149.758 54.9902C150.125 55.1002 150.455 55.3008 150.715 55.5718C150.974 55.8428 151.155 56.1746 151.238 56.5336C151.32 56.8927 151.303 57.2663 151.186 57.6166Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1479 168.439H55.498V177.044H95.1479V168.439Z",
    fill: "#407BFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.5189 168.439H59.4453V177.044H60.5189V168.439Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.0346 168.439H64.9609V177.044H66.0346V168.439Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.5463 177.044H70.4727V168.439L71.5463 168.591V177.044Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.0639 168.439H75.9902V177.044H77.0639V168.439Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.5814 168.439H81.5078V177.044H82.5814V168.439Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.0932 168.439H87.0195V177.044H88.0932V168.439Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.6088 168.439H92.5352V177.044H93.6088V168.439Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M95.1479 168.439H55.498V170.213H95.1479V168.439Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33 159.83H61.6797V168.435H101.33V159.83Z",
    fill: "#407BFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.6986 159.83H65.625V168.435H66.6986V159.83Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.2162 159.83H71.1426V168.435H72.2162V159.83Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.7338 159.83H76.6602V168.435H77.7338V159.83Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.2455 159.83H82.1719V168.435H83.2455V159.83Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7611 159.83H87.6875V168.435H88.7611V159.83Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.2748 159.83H93.2012V168.435H94.2748V159.83Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.7924 159.83H98.7188V168.435H99.7924V159.83Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M101.33 159.83H61.6797V161.603H101.33V159.83Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8178 151.225H56.168V159.829H95.8178V151.225Z",
    fill: "#407BFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.1869 151.225H60.1133V159.829H61.1869V151.225Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.6986 159.834H65.625V151.233L66.6986 151.225V159.834Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.2162 151.225H71.1426V159.829H72.2162V151.225Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.7338 151.225H76.6602V159.829H77.7338V151.225Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.2455 159.834H82.1719V151.225L83.2455 151.233V159.834Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7611 151.225H87.6875V159.829H88.7611V151.225Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.2748 151.225H93.2012V159.829H94.2748V151.225Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M95.8178 151.225H56.168V153.345H95.8178V151.225Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33 142.625H61.6797V151.23H101.33V142.625Z",
    fill: "#407BFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.6986 142.625H65.625V151.23H66.6986V142.625Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.2162 142.625H71.1426V151.23H72.2162V142.625Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.7338 142.625H76.6602V151.23H77.7338V142.625Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.2455 142.625H82.1719V151.23H83.2455V142.625Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7631 142.625H87.6895V151.23H88.7631V142.625Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.2748 151.225L93.2012 151.234V142.625L94.2748 142.781V151.225Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.7924 142.625H98.7188V151.23H99.7924V142.625Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M101.33 142.625H61.6797V144.398H101.33V142.625Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103.074 134.021H63.4238V142.626H103.074V134.021Z",
    fill: "#407BFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.4428 134.021H67.3691V142.626H68.4428V134.021Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.9545 134.021H72.8809V142.626H73.9545V134.021Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.4721 134.021H78.3984V142.626H79.4721V134.021Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.9877 134.021H83.9141V142.626H84.9877V134.021Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.4994 134.021H89.4258V142.626H90.4994V134.021Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.017 134.021H94.9434V142.626H96.017V134.021Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.531 134.021H100.457V142.626H101.531V134.021Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M103.074 134.021H63.4238V135.795H103.074V134.021Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3549 125.416H58.7051V134.021H98.3549V125.416Z",
    fill: "#407BFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.726 125.416H62.6523V134.021H63.726V125.416Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.2416 125.416H68.168V134.021H69.2416V125.416Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.7533 125.416H73.6797V134.021H74.7533V125.416Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.2709 125.416H79.1973V134.021H80.2709V125.416Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.7826 125.416H84.709V134.021H85.7826V125.416Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.3002 125.416H90.2266V134.021H91.3002V125.416Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8158 125.416H95.7422V134.021H96.8158V125.416Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M98.3549 125.416H58.7051V127.189H98.3549V125.416Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5717 168.568H5.92188V177.173H45.5717V168.568Z",
    fill: "#407BFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.9408 168.568H9.86719V177.173H10.9408V168.568Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4584 168.568H15.3848V177.173H16.4584V168.568Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.974 168.568H20.9004V177.173H21.974V168.568Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4857 168.568H26.4121V177.173H27.4857V168.568Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.0033 168.568H31.9297V177.173H33.0033V168.568Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.515 168.568H37.4414V177.173H38.515V168.568Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.0326 168.568H42.959V177.173H44.0326V168.568Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M45.5717 168.568H5.92188V170.342H45.5717V168.568Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4448 159.963H7.79492V168.568H47.4448V159.963Z",
    fill: "#407BFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8139 159.963H11.7402V168.568H12.8139V159.963Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3314 159.963H17.2578V168.568H18.3314V159.963Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.8432 159.963H22.7695V168.568H23.8432V159.963Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.3588 159.963H28.2852V168.568H29.3588V159.963Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8725 159.963H33.7988V168.568H34.8725V159.963Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.3881 159.963H39.3145V168.568H40.3881V159.963Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.9057 159.963H44.832V168.568H45.9057V159.963Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M47.4448 159.963H7.79492V161.585H47.4448V159.963Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0131 151.354H5.36328V159.958H45.0131V151.354Z",
    fill: "#407BFF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.3822 151.354H9.30859V159.958H10.3822V151.354Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8998 151.354H14.8262V159.958H15.8998V151.354Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4115 151.354H20.3379V159.958H21.4115V151.354Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.9291 151.354H25.8555V159.958H26.9291V151.354Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.4447 151.354H31.3711V159.958H32.4447V151.354Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.9584 151.354H36.8848V159.958H37.9584V151.354Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.476 151.354H42.4023V159.958H43.476V151.354Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M45.0131 151.354H5.36328V152.976H45.0131V151.354Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M132.112 147.039H123.426V177.405H132.112V147.039Z",
    fill: "#407BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.112 155.119V161.293L123.426 169.6V162.959L132.112 155.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.112 150.604V151.652L123.426 159.964V158.915L132.112 150.604Z",
    fill: "white"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M142.806 156.822H134.119V177.405H142.806V156.822Z",
    fill: "#407BFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.806 162.889V169L134.119 177.303V170.733L142.806 162.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.806 160.008V161.181L134.119 169.493V168.31L142.806 160.008Z",
    fill: "white"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M121.413 132.447H112.727V177.405H121.413V132.447Z",
    fill: "#407BFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.418 140.887V147.029L112.727 155.336V148.732L121.418 140.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.418 137.51V138.656L112.727 146.972V145.817L121.418 137.51Z",
    fill: "white"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M118.126 136.207C117.996 136.407 117.806 136.565 117.582 136.662C117.357 136.759 117.107 136.79 116.864 136.751C116.621 136.712 116.396 136.605 116.216 136.443C116.037 136.282 115.911 136.073 115.856 135.843C115.801 135.614 115.818 135.373 115.905 135.153C115.993 134.933 116.147 134.742 116.347 134.606C116.548 134.469 116.787 134.392 117.033 134.385C117.28 134.378 117.523 134.441 117.731 134.567C118.01 134.735 118.208 135.002 118.282 135.309C118.356 135.616 118.3 135.939 118.126 136.207Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M128.82 150.643C128.69 150.842 128.501 150.998 128.277 151.094C128.053 151.19 127.805 151.22 127.563 151.181C127.321 151.142 127.097 151.035 126.919 150.874C126.741 150.714 126.616 150.506 126.561 150.277C126.506 150.049 126.523 149.81 126.61 149.591C126.696 149.372 126.849 149.182 127.049 149.045C127.248 148.909 127.485 148.832 127.73 148.825C127.975 148.817 128.217 148.879 128.425 149.003C128.564 149.086 128.685 149.194 128.78 149.321C128.875 149.448 128.943 149.592 128.98 149.745C129.016 149.897 129.021 150.055 128.994 150.209C128.966 150.363 128.908 150.511 128.82 150.643Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M139.516 160.421C139.386 160.62 139.197 160.778 138.973 160.874C138.749 160.971 138.501 161.001 138.259 160.963C138.017 160.924 137.792 160.817 137.613 160.657C137.435 160.496 137.31 160.288 137.254 160.059C137.199 159.831 137.216 159.591 137.303 159.372C137.39 159.152 137.543 158.963 137.743 158.826C137.943 158.69 138.18 158.613 138.425 158.606C138.671 158.599 138.913 158.661 139.121 158.786C139.26 158.868 139.38 158.975 139.475 159.102C139.57 159.229 139.638 159.373 139.675 159.525C139.711 159.677 139.716 159.834 139.689 159.988C139.662 160.142 139.603 160.289 139.516 160.421Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M138.466 159.782L127.441 169.6L127.767 150.012L117.072 156.337V135.576",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9616 61.6894C38.9616 61.6894 36.001 65.8673 35.3085 66.2985C34.616 66.7296 25.2694 65.0317 20.6821 62.7428L18.3164 59.9071L14.7469 58.707L12.6973 62.6005L15.5277 64.3784C15.5277 64.3784 17.3404 66.374 19.3714 65.8184C19.3714 65.8184 26.6777 70.3786 31.9203 71.5431C37.163 72.7076 38.376 71.3609 39.9051 70.1697C41.4342 68.9786 45.4824 63.3294 45.4824 63.3294L38.9616 61.6894Z",
    fill: "#B55B52"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0566 44.115C67.0566 44.115 78.7503 40.7016 82.7102 37.8703C82.7102 37.8703 88.7197 30.8389 89.719 23.3319L88.3665 19.4251L89.0823 14.9805L93.5348 15.9316C93.5348 15.9316 95.8587 20.6074 93.0282 24.2697C93.0282 24.2697 92.2706 35.1502 87.4509 40.8216C82.6312 46.4929 67.554 50.2842 67.554 50.2842L67.0566 44.115Z",
    fill: "#B55B52"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2497 85.207L70.2923 52.3167L77.8077 48.881L72.9787 40.6406C72.9787 40.6406 67.1179 42.2851 62.0425 42.2851C55.2987 42.2851 48.513 47.1742 44.8459 48.561C41.1788 49.9477 37.1074 61.8726 37.1074 61.8726L45.5849 66.215L47.1744 61.7437C47.1744 61.7437 49.4565 78.2689 49.4658 85.5181L71.2497 85.207Z",
    fill: "#407BFF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.2497 85.207L70.2923 52.3167L77.8077 48.881L72.9787 40.6406C72.9787 40.6406 67.1179 42.2851 62.0425 42.2851C55.2987 42.2851 48.513 47.1742 44.8459 48.561C41.1788 49.9477 37.1074 61.8726 37.1074 61.8726L45.5849 66.215L47.1744 61.7437C47.1744 61.7437 49.4565 78.2689 49.4658 85.5181L71.2497 85.207Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1044 39.2846C54.1044 39.2846 48.2343 39.8713 47.17 35.4044C47.17 35.4044 43.6656 34.071 46.1568 30.7642C46.1568 30.7642 42.9313 26.1729 47.0492 24.8084C47.6121 23.5127 48.4902 22.3641 49.6106 21.4581C50.731 20.5521 52.0612 19.9148 53.4909 19.5993C56.8233 18.817 55.8799 20.5282 55.8799 20.5282C55.8799 20.5282 62.791 17.9726 63.781 20.8216C64.771 23.6706 59.3889 24.9329 59.3889 24.9329L54.1044 39.2846Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7571 38.4519C57.7743 38.7188 57.8084 38.9845 57.8593 39.2475C58.0963 40.5809 59.0538 42.7054 61.3776 43.4076C61.3776 43.4076 61.6983 45.7811 57.8593 45.3722C54.0203 44.9633 52.1937 44.3099 52.1937 44.3099C52.7818 41.4385 52.7438 38.4819 52.0822 35.6251C52.0822 35.6251 49.9163 35.9718 48.694 34.7895C47.4716 33.6072 47.9132 30.616 51.7382 32.3094C51.7382 32.3094 52.5655 27.9492 49.8791 26.638C49.8791 26.638 55.1404 27.367 59.3466 24.918C59.3466 24.918 62.9765 29.3626 62.4699 33.6072C61.9633 37.8519 57.7571 38.4519 57.7571 38.4519Z",
    fill: "#B55B52"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M58.691 33.327C58.691 33.327 57.3246 34.1759 55.7676 32.9492",
    stroke: "#263238",
    strokeWidth: 0.722314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4979 29.6593C55.5816 29.9838 55.8186 30.206 56.0278 30.1571C56.2369 30.1082 56.3392 29.806 56.2555 29.4815C56.1718 29.1571 55.9348 28.9304 55.7257 28.9793C55.5165 29.0282 55.391 29.3349 55.4979 29.6593Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1464 28.3581C59.2301 28.687 59.4671 28.9092 59.6762 28.8603C59.8854 28.8115 59.9876 28.5048 59.904 28.1803C59.8203 27.8559 59.5833 27.6336 59.3741 27.6825C59.165 27.7314 59.0627 28.0336 59.1464 28.3581Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M55.256 27.3008C54.9421 27.3836 54.6619 27.5553 54.452 27.7932C54.2421 28.0312 54.1124 28.3244 54.0801 28.6342",
    stroke: "#263238",
    strokeWidth: 0.963085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2152 0.770126C56.2152 0.770126 55.3879 0.178989 54.6582 0.685677",
    stroke: "#263238",
    strokeWidth: 0.963085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2532 31.6738L58.3887 28.9492L60.8241 30.8871C60.6928 31.1679 60.4663 31.3983 60.1813 31.5411C59.8963 31.6838 59.5694 31.7305 59.2532 31.6738Z",
    fill: "#A02724"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M57.8586 39.2604C57.5083 39.3215 57.1483 39.3102 56.8028 39.2274C56.4573 39.1446 56.1344 38.9922 55.8555 38.7804C56.5666 38.7093 57.7564 38.4648 57.7564 38.4648C57.7736 38.7318 57.8078 38.9975 57.8586 39.2604Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9239 45.4342L59.9007 49.6922L57.7162 49.8833C57.7162 49.8833 56.0477 48.3188 55.9408 47.5009C55.8339 46.6831 58.3437 44.5364 59.9239 45.4342Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5837 49.2578C59.5837 49.2578 62.865 60.8139 64.4406 66.5919L62.6465 70.0098L59.6255 67.1252L57.9941 49.4489L59.5837 49.2578Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5914 154.014L67.9359 155.014C67.9359 155.014 65.8862 130.697 65.361 121.577C65.2727 119.999 65.1054 118.319 64.8962 116.612C63.8645 108.425 61.7544 99.6737 61.7544 99.6737C61.7544 99.6737 61.0665 114.274 59.1609 125.453C57.2554 136.631 49.1915 153.009 49.1915 153.009L42.8613 150.223C47.8065 136.693 48.9406 119.843 49.3682 113.541C49.7958 107.238 49.3124 81.3174 49.3124 81.3174L71.1103 80.4062C73.2157 90.22 75.9532 112.652 76.2553 120.408C76.5574 128.164 74.5914 154.014 74.5914 154.014Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M75.651 153.176L67.2246 154.736L67.6383 157.238L75.4929 155.874L75.651 153.176Z",
    fill: "#407BFF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M47.829 153.705L45.5051 158.443L41.7637 157.061L44.2595 152.123L47.829 153.705Z",
    fill: "#B55B52"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5519 151.973L42.5213 150.119L41.7266 152.621L49.9205 154.924L51.5519 151.973Z",
    fill: "#407BFF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M64.8917 116.678C63.8599 108.495 61.7498 99.7395 61.7498 99.7395L60.8574 88.8457C60.8574 88.8457 65.8956 107.664 64.8917 116.678Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4258 43.0117C54.0799 44.0971 55.9182 44.9001 57.859 45.3852L56.4275 49.4164C56.4275 49.4164 52.9278 47.8786 51.1523 46.4874L52.4258 43.0117Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8594 45.3875L60.2158 48.881C61.2955 47.4521 62.0767 45.8373 62.5164 44.1252L59.8672 42.2852C59.8672 42.2852 58.7517 44.6141 57.8594 45.3875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1261153142);
export default __webpack_public_path__ + "static/media/Group 1261153142.a875676818787b9d14f294cc64d3257c.svg";
export { ForwardRef as ReactComponent };